import SharedHelper from '@/Helpers/Shared';
export default {
  inject: ['load'],
  data() {
    return {};
  },
  mixins: [SharedHelper],
  methods: {
    addNewNotification: function (body) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('addNewNotificationDispatch', body)
        .then(() => {
          if (this.$store.state.Notifications800Module.successFlag) {
            this.onAddSuccess();
          } else {
            if (this.$store.state.Notifications800Module.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.addNewNotification(body);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.Notifications800Module.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.addNewNotification(body);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.onError();
            }
          }
        })
        .finally(() => {
          if (this.load.val) {
            this.load.val = false;
          }
        });
    },
    editNotification: function (body) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('editNotificationDispatch', body)
        .then(() => {
          if (this.$store.state.Notifications800Module.successFlag) {
            this.onEditSuccess();
          } else {
            if (this.$store.state.Notifications800Module.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.editNotification(body);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.Notifications800Module.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.editNotification(body);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.onError();
            }
          }
        })
        .finally(() => {
          if (this.load.val) {
            this.load.val = false;
          }
        });
    },
    onAddSuccess: function () {
      this.showSuccessAlert('اعلان جدید ایجاد شد', 5000);
      this.$router.replace({ name: 'notification_for_800' });
    },
    onEditSuccess: function () {
      this.showSuccessAlert('اعلان ویرایش شد', 5000);
      this.$router.replace({ name: 'notification_for_800' });
    },
    onError: function () {
      const message = this.$store.state.Notifications800Module.error;
      this.showErrorAlert(message, 8000);
    },
  },
};
